import '../styles/pages/gallery.scss'
import { useState } from 'react';
import GalleryData from '../data/GalleryData';
import Modal from '../components/ui/Modal';
import Button from '../components/ui/Button';



const FanArt = () => {

    const [current, changeCurrent] = useState(1)
    const setCurrent = (index) =>{
        changeCurrent(index)
    }

    return (
        <div className="page-container">
            <div className="line-container">
                <h1 className="gallery-title">
                    FAN ART GALLERY
                </h1>
                <div className="story-wrapper">
                    <p>It’s the SSS (and some of their friends!) as you’ve never seen them before! The Trails From Zero Fan Art Gallery contains art collected and submitted between June 13, 2022 and August 11, 2022 from all corners of the community. Thank you to all of the talented and passionate artists who contributed their amazing work! We hope you enjoy!</p>
                </div>
                <section className="gallery-container">
                    {
                        GalleryData.map((art, index)=>{
                            return (
                                <>
                                    <Modal component={<GalleryFull index={index} current={current} changeArt={setCurrent}/>}>
                                        <div className="character-image" style={{
                                            backgroundImage: `url(./img/gallery/icon/${art.image}.webp)`
                                        }} onClick={()=>setCurrent(index)}>
                                            <h1>{art.handle}</h1>
                                        </div>
                                    </Modal>
                                </>
                            )
                        })
                    }
                </section>
                <section className="disclaimer">
                    <h1>NIS America is not responsible for an artist's body of work unrelated to the gallery.</h1>
                    <h1>Please contact pr-na@nisamerica.com if you have any questions or concerns pertaining to the gallery.</h1>
                    <h1>Please be respectful of both the artwork and the artists.</h1>
                </section>
            </div>
        </div>
    )
}

const GalleryFull = ({index, changeArt, current}) => (
    <div className="gallery-wrapper">
        <img src={`./img/gallery/${GalleryData[current].image}.webp`} alt="" className="gallery-image"/>
        <h1 className="artist-handle">
            {`${GalleryData[current].platform}: ${GalleryData[current].handle}`}
        </h1>
        <div className="next-container">
            {
                (current !== 0) && <Button
                    text="Previous"
                    type="gradient"
                    color="blue"
                    onClick={()=>{
                        if(index >= 0) {
                            changeArt(current-1)
                        }
                    }}
                />
            }
            {
                (current !== GalleryData.length-1) && <Button
                    text="Next"
                    type="gradient"
                    color="blue"
                    onClick={()=>{
                        if(current !==  GalleryData.length-1) {
                            changeArt(current+1)
                            console.log(current+1)
                        }
                    }}
                />
            }
        </div>
    </div>
)

export default FanArt;



/*
const Submission = () => (
    <> 
    <article className="gallery-desc">
                <p>
                It’s the SSS as you’ve never seen them before! The Trails From Zero Fan Art Gallery will showcase art collected and submitted from all corners of the community! Whether it be Lloyd, Elie, Tio, Randy, or another citizen, guest, ally, or enemy of Crossbell, this gallery will include a lineup of artwork you won’t want to miss!
                </p>
                <p>
                    We are accepting submissions from June 13, 2022 to August 11th, 2022. The gallery will then go live on this page on August 29th, 2022. 
                </p>
                <p>
                    If you would like to submit a piece of art for consideration, please read the following rules and disclaimers.
                </p>
            </article>
            <section className="rules-container">
                <h1>Rules/Disclaimers:</h1>
                <ul>
                    <li>Accepted File Formats: webp, jpeg, png</li>
                    <li>Accepted File Size: 500KB and under. </li>
                    <li>Accepted File Dimensions: 5:4, 4:3, 1:1,16:9</li>
                    <li>You are giving NIS America, Inc. permission to display your artwork in the Trails From Zero Fan Art gallery.</li>
                    <li>By submitting your intellectual property into the Trails from Zero Fan Art gallery, you are granting NIS America, Inc. the right to alter, crop, and edit any submissions for future use. </li>
                    <li>
                    Any artwork you submit for consideration in this gallery may also be posted on your website, portfolio, social media channels, or other platform of choice. 
                    </li>
                    <li>NIS America, Inc. reserves the right to reject any artwork depicting inappropriate and/or graphic content, at our sole discretion.</li>
                    <li>Artwork displaying logos, product brands, and/or store names other than those associated with The Legend of Heroes: Trails From Zero is ineligible.</li>
                    <li>Any artwork submitted should be created by you, the artist. NIS America, Inc. will not accept any artwork you submit that was created by another artist. Should NIS America, Inc. discover that your artwork was created by another artist, it will be rejected and removed from consideration for the gallery. </li>
                    <li>Please include a second page with your artwork that contains a link/URL to your portfolio, website, Instagram, Twitter, or other platform of your choosing. We want to make sure that your participation in this gallery allows people to view your work!</li>
                    <li>NIS America is not responsible for an artist's body of work unrelated to this gallery</li>
                </ul>
            </section>
            <div className="submission-link">
                <h1>Please submit your artwork by using the following link:</h1>
                <a href="https://www.dropbox.com/request/VYbaCeFCvWPKvk8zk1dB" target="_blank" rel="noopener noreferrer">
                    Dropbox
                </a>
                <h1>
                    Contact pr-na@nisamerica.com if you have any questions or concerns pertaining to the gallery.
                </h1>
            </div></>
)

*/
